<template>
    <div class="clearfix backgroundi" id="login_wrap">
      <div style="display: flex;justify-content: space-between;align-items: center;padding: 50px;">
        <div style="font-size: 30px;color: #026343;">联系官方查看演示站</div>
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <div style="margin: 0 40px;font-size: 35px;color: #026343;" @click="topath('/login')">客户端登录</div>
          <div style="margin: 0 40px;font-size: 35px;font-weight: 600; color: #026343;">账号注册</div>
          <div style="margin: 0 40px;font-size: 35px;color: #026343;">厂家登录</div>
          <div style="margin: 0 40px;font-size: 35px;color: #026343;">合作推广</div>
          <div style="margin: 0 40px;font-size: 35px;color: #026343;">视频教学</div>
        </div>
      </div>
      <!-- 内容区域 -->
      <div class="backgroundbox" style="padding-top: 40px;margin-left: 60%;">
        <div style="width: 100%;height: 80%;margin-top: 200px;background: #fff;border-radius: 1.5vw 1.5vw 0 0;">
            <div style="display: flex;justify-content: space-between;">
                <div :class="logintype==1?'phonelogin':'logintitle'" @click="logintypechange(1)">代理商注册</div>
                <div :class="logintype==2?'wxlogin':'logintitle'" @click="logintypechange(2)">厂家注册</div>
            </div>
            <!-- 代理商注册 -->
            <div style="display: flex;flex-direction: column;align-items: center;" v-if="logintype==1 && !apply">
                <div style="margin: 10px 0; width: 80%;min-width: 200px;">
                    <el-input v-model="site.prefix" placeholder="请输入站点前缀 字母或数字都行"></el-input>
                    <div style="color: #FF0000;text-align: center;font-size: 15px; font-weight: 600;margin-top: 5px;">如:xXX.08170817.com 这里的XXX可以自定</div>
                </div>
                <div style="margin: 10px 0;width: 80%;">
                    <el-input v-model="site.username" placeholder="请输入老板您的手机号"></el-input>
                </div>
                <div style="margin: 10px 0;width: 80%;">
                    <el-input v-model="site.password1" placeholder="请输入老板您的密码" show-password></el-input>
                </div>
                <div style="margin: 10px 0;width: 80%;">
                    <el-input v-model="site.password2" placeholder="请再次输入老板您的密码" show-password></el-input>
                    <div style="color: #FF0000;text-align: center;font-size: 15px; font-weight: 600;margin-top: 5px;" v-if="site.password1!=site.password2">两次输入密码不一致</div>
                </div>
                <div style="display: flex;">
                    <div :class="selectThailid==index?'paycardd':'paycard'" v-for="(item,index) in thail" :key="index" @click="selectThail(index)">
                        <div style="font-size: 30px;">{{ item.name }}</div>
                        <div style="display: flex;flex-direction: column;align-items: flex-end;">
                            <div style="font-size: 15px;color: #FF0000;font-weight: 600;">现价{{ item.price }}</div>
                            <div style="font-size: 15px;text-decoration: line-through;">原价{{ item.oldprice }}</div>
                        </div>
                    </div>
                </div>
                <div class="registerbtn" @click="register">立即注册(支付{{thail[selectThailid]['price']}}元)</div>
            </div>
            <div style="margin-top: 50px; font-size: 20px;text-align: center;color: #FF0000;" v-if="logintype==1 && apply">
                代理商信息管理员审核中，敬请期待！
            </div>
            <!-- 厂家注册 -->
            <div style="display: flex;flex-direction: column;align-items: center;margin-top: 1.5vw;" v-if="logintype==2">
                <el-image style="width: 15vw; height: 15vw" :src="url" :lazy="true"></el-image>
                <div style="font-size: 1vw;margin-top: 1vw;">微信扫描登录后台</div>
            </div>
        </div>
      </div>
        <el-dialog title="微信支付" :visible.sync="dialogpayVisible" width="30%">
            <div style="display: flex;justify-content: center;flex-direction: column;align-items: center;">
                <el-image style="width: 200px; height: 200px" :src="qreCodeUrl" fit="fill"></el-image>
                <div style="font-size: 20px;">请使用微信支付 ￥{{thail[selectThailid]['price']}}元</div>
            </div>
            
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogpayVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogpayVisible = false">已 支 付</el-button>
            </span>
        </el-dialog>
    </div>
  </template>
  
  <script>
  import { mapMutations } from "vuex";
  import QRCode from 'qrcode';
  export default {
    data() {
      return {
        dialogpayVisible:false,
        timerId:'',
        qreCodeUrl:'',
        thail:[],
        apply:{},
        selectThailid:0,
        logintype:1,
        site:{
            prefix:'',
            username:'',
            password1:'',
            password2:'',
            thailid:0,
        }
      };
    },
    created(e){
      const token = this.$route.query.token;
      clearTimeout(this.timerId);
      if(token){
        // 存储登录信息
        this.setUser({ username: "admin", token: token });
          // 跳转页面
        this.$router.push("/");
      }
      this.getdata()
    },
    methods: {
        async getdata(){
            const registerid = localStorage.getItem('registerid');
            let res = await this.$api.registermaterial({orderid:registerid})
            this.thail = res.data.data.thail
            this.apply = res.data.data.apply
            this.selectThail(0)
        },
        selectThail(index){
            this.selectThailid = index
            this.site['thailid'] = this.thail[index]['id']
        },
        async register(){
            let res = await this.$api.register(this.site)
            clearTimeout(this.timerId);
            if(res.data.code==200){
                this.qreCodeUrl = await QRCode.toDataURL(res.data.data.code_url);
                console.log('this.qreCodeUrl',this.qreCodeUrl)
                this.dialogpayVisible = true
                this.timerId = setInterval(async () => {
                    await this.getregister(res.data.data.wxdata.out_trade_no); // 注意这里的await，确保不会阻塞事件循环
                }, 2000);
            }else{
                this.$notify({
                    title: '警告',
                    message: res.data.msg,
                    type: 'warning'
                });
            }
        },
        async getregister(orderid){
            let res = await this.$api.getregister({orderid:orderid})
            console.log('res',res.data)
            if(res.data.data.status==2){
                this.$notify({
                    title: '支付成功!',
                    message: '您已支付成功，等待管理员审核！',
                    type: 'success'
                });
                localStorage.setItem('registerid', res.data.data.orderid);
                this.dialogpayVisible = false
                clearTimeout(this.timerId);
                this.getdata()
            }
        },
        topath(e){
            this.$router.push(e);
        },
        logintypechange(type){
            
            this.logintype = type
            console.log('this.logintype', this.logintype)
        },
    },
  };
  </script>
  
  <style scoped lang="less">
  .title {
    text-align: center;
    font-size: 22px;
  }
  
  #login_wrap {
    position: relative;
    background: rgba(64, 64, 194, 0.1);
    height: 100%;
  }
  
  .info {
    color: #999;
    margin-top: 8px;
    text-align: center !important;
  }
  .backgroundi {
    background-image: url("https://kaifaceshi.08170817.com/static/admin/loginbg.png") !important;
    /* 设置图片路径 */
    background-size: cover !important;
    /* 背景图片覆盖整个元素 */
    background-repeat: no-repeat !important;
    /* 背景图片不重复 */
    background-position: center !important;
    /* 背景图片居中 */
    width: 100vw;
    /* 元素宽度 */
    height: 25vw;
    /* 元素高度 */
  }
  .backgroundbox{
    background-image: url("https://kaifaceshi.08170817.com/static/admin/loginbox.png") !important;
    /* 设置图片路径 */
    background-size: cover !important;
    /* 背景图片覆盖整个元素 */
    background-repeat: no-repeat !important;
    /* 背景图片不重复 */
    background-position: center !important;
    /* 背景图片居中 */
    width: 700px;
    /* 元素宽度 */
    height: 80%;
    /* 元素高度 */
  }
  .logintitle{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50%;
    height: 80px;
    font-size: 25px;
    font-weight: 600;
  }
  .phonelogin{
    display: flex;align-items: center;
    justify-content: center;
    width: 50%;
    height: 80px;
    font-size: 25px;
    font-weight: 600;
    background: linear-gradient(to right,#E2FEC4,#C0FEEC);
    border-radius: 1.5vw 0 5vw 0;
  }
  .wxlogin{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50%;
    height: 80px;
    font-size: 25px;
    font-weight: 600;
    background: linear-gradient(to right,#E2FEC4,#C0FEEC);
    border-radius: 0 1.5vw 0 5vw;
  }
  .paycard{
    padding: 10px; 
    margin: 0 10px; 
    background-color: #026343;
    color: #fff;
    border-radius: 5px;
    font-size: 18px;
    min-width: 150px;
  }
  .paycardd{
    padding: 10px; 
    margin: 0 10px; 
    background-color: #866700;
    color: #fff;
    border-radius: 5px;
    font-size: 18px;
    min-width: 150px;
  }
  .registerbtn{
    display: flex;
    justify-content: center;
    align-items:center;
    margin: 20px auto;
    background: linear-gradient(to right,#E2FEC4,#C0FEEC);
    width: 500px;
    height: 80px;
    border-radius: 0.5vw;
    color: #866700;
    font-size: 30px;
    font-weight: 600;
  }
  /deep/ .el-input__inner{
    height: 3vw;
    font-size: 1vw;
    font-weight: 600;
    background: #EAFFBB;
    border: 0;
    border-radius: 0.75vw;
  }
  </style>
  